export default "__VITE_ASSET__fdTPFCuv__"